import React from 'react';
import { GithubIcon, LinkedinIcon, MailIcon, HeartIcon } from 'lucide-react';
export function Footer() {
  const currentYear = new Date().getFullYear();
  return <footer className="py-12 px-4 border-t border-slate-800" role="contentinfo" data-id="element-189">
      <div className="max-w-6xl mx-auto" data-id="element-190">
        <div className="flex flex-col items-center gap-6" data-id="element-191">
          {/* Social Links */}
          <nav aria-label="Social media links" data-id="element-192">
            <ul className="flex items-center gap-4" data-id="element-193">
              <li data-id="element-194">
                <a href="https://github.com/Pet3r1512" className="w-10 h-10 flex items-center justify-center rounded-lg bg-slate-800 border border-slate-700 text-slate-400 hover:text-emerald-400 hover:border-emerald-500/50 transition-all focus:outline-none focus-visible:ring-2 focus-visible:ring-emerald-400 focus-visible:ring-offset-2 focus-visible:ring-offset-slate-950" aria-label="GitHub profile" data-id="element-195">
                  <GithubIcon className="w-5 h-5" aria-hidden="true" data-id="element-196" />
                </a>
              </li>
              <li data-id="element-197">
                <a href="https://www.linkedin.com/in/peterpham1512/" className="w-10 h-10 flex items-center justify-center rounded-lg bg-slate-800 border border-slate-700 text-slate-400 hover:text-emerald-400 hover:border-emerald-500/50 transition-all focus:outline-none focus-visible:ring-2 focus-visible:ring-emerald-400 focus-visible:ring-offset-2 focus-visible:ring-offset-slate-950" aria-label="LinkedIn profile" data-id="element-198">
                  <LinkedinIcon className="w-5 h-5" aria-hidden="true" data-id="element-199" />
                </a>
              </li>
              <li data-id="element-200">
                <a href="mailto:peter1512.dev@gmail.com" className="w-10 h-10 flex items-center justify-center rounded-lg bg-slate-800 border border-slate-700 text-slate-400 hover:text-emerald-400 hover:border-emerald-500/50 transition-all focus:outline-none focus-visible:ring-2 focus-visible:ring-emerald-400 focus-visible:ring-offset-2 focus-visible:ring-offset-slate-950" aria-label="Send email" data-id="element-201">
                  <MailIcon className="w-5 h-5" aria-hidden="true" data-id="element-202" />
                </a>
              </li>
            </ul>
          </nav>

          {/* Tagline */}
          <p className="text-slate-400 text-sm text-center" data-id="element-203">
            Building tools that make developers' lives easier.
          </p>

          {/* Copyright */}
          <div className="flex items-center gap-1.5 text-slate-500 text-sm" data-id="element-204">
            <span data-id="element-205">© {currentYear} Peter Pham. Made with</span>
            <HeartIcon className="w-4 h-4 text-red-500 fill-red-500" aria-hidden="true" data-id="element-206" />
            <span className="sr-only" data-id="element-207">love</span>
            <span data-id="element-208">and lots of coffee.</span>
          </div>
        </div>
      </div>
    </footer>;
}